module.exports = __webpack_public_path__ + "static/media/example-3.9958892c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/VanMasters/example-3.jpg
// module id = 259
// module chunks = 0